import type { EdgeType } from './data/schema'

export const relationshipColors: Record<EdgeType, string> = {
  family: '#D7B56D',
  help: '#70B79A',
  conflict: '#DF7666',
  love: '#D889AC',
  participation: '#7999BD',
  geography: '#6DAA86',
  causality: '#A98BCE',
  creation: '#C58A45',
  possession: '#B58C62',
}

export const relationshipTypes: EdgeType[] = [
  'family',
  'help',
  'conflict',
  'love',
  'participation',
  'geography',
  'causality',
  'creation',
  'possession',
]
